module.exports = __webpack_public_path__ + "img/lalamove_charge_logo.9df27559.png";